<!--Email Graph view-->
<div class="email-graph-section">
    <div class="email-graph-wrapper">
        <!-- Collapsible Header -->
        <div class="collapsible-header" (click)="toggleEmailGraph('emailsPerWeek')">
            <span class="collapse-icon" [ngClass]="{'collapsed': !showEmailGraphPerWeek}">▼</span>
            <span class="material-icons section-icon">bar_chart</span>
            <h3 class="section-title">Emails per Week</h3>
        </div>

        <!-- Collapsible Content -->
        <div class="collapsible-content" *ngIf="showEmailGraphPerWeek">
            <svg #emailsPerWeekChart class="email-chart"></svg>
        </div>
    </div>

    <div class="email-graph-wrapper">
        <!-- Collapsible Header -->
        <div class="collapsible-header" (click)="toggleEmailGraph('emailsByDay')">
            <span class="collapse-icon" [ngClass]="{'collapsed': !showEmailGraphByDay}">▼</span>
            <span class="material-icons section-icon">bar_chart</span>
            <h3 class="section-title">Emails by Day of Week</h3>
        </div>

        <!-- Collapsible Content -->
        <div class="collapsible-content" *ngIf="showEmailGraphByDay">
            <svg #emailsByDayChart class="email-chart"></svg>
        </div>
    </div>
</div>
